import { Currency, RevenuePeriod } from '@vendasta/sales-orders';
import { BillingFrequency } from '@vendasta/shared';

export function convertSalesOrderCurrencyToString(currency: Currency): string {
  return Currency[currency] ? Currency[currency] : Currency[Currency.USD];
}

export function getPeriodTranslationKey(period: RevenuePeriod): string {
  switch (period || RevenuePeriod.ONETIME) {
    case RevenuePeriod.ONETIME:
      return 'FRONTEND.STORE.PERIODS.ONE_TIME';
    case RevenuePeriod.DAILY:
      return 'FRONTEND.STORE.PERIODS.DAILY';
    case RevenuePeriod.WEEKLY:
      return 'FRONTEND.STORE.PERIODS.WEEKLY';
    case RevenuePeriod.BIWEEKLY:
      return 'FRONTEND.STORE.PERIODS.BIWEEKLY';
    case RevenuePeriod.MONTHLY:
      return 'FRONTEND.STORE.PERIODS.MONTHLY';
    case RevenuePeriod.YEARLY:
      return 'FRONTEND.STORE.PERIODS.YEARLY';
    default:
      return '';
  }
}

export function salesOrderPeriodToBillingFrequency(period: RevenuePeriod): BillingFrequency {
  switch (period || RevenuePeriod.ONETIME) {
    case RevenuePeriod.ONETIME:
      return 'once';
    case RevenuePeriod.DAILY:
      return 'daily';
    case RevenuePeriod.WEEKLY:
      return 'weekly';
    case RevenuePeriod.BIWEEKLY:
      return 'other';
    case RevenuePeriod.MONTHLY:
      return 'monthly';
    case RevenuePeriod.YEARLY:
      return 'yearly';
    default:
      return 'other';
  }
}
